export default __webpack_public_path__ + "static/media/space_part5.6b9e7067.png";